import React from 'react';
import { Toast, ToastContainer } from "react-bootstrap";

const ToastMessage = ( { show, handleClose, message, type } ) =>
{
	return (
		<ToastContainer position="bottom-center" className="w-100 text-center" delay={2000} autohide="true">
			<Toast position="bottom-center" className={"m-auto " + ( type === "danger" && "bg-danger" )} onClose={handleClose} show={show}  delay={2000} autohide={"true"}>
				<Toast.Body style={{ "direction" : "ltr" }} className={"text-center " + ( type === "danger" && "text-white" )}>{message}</Toast.Body>
			</Toast>
		</ToastContainer>
	);
};

export default ToastMessage;
